import { SyncService } from '@client/services/sync';

import { SYNC_CONNECTIONS } from '@client/enums';

const connectionsEnum = { ...SYNC_CONNECTIONS };

export const checkConnections = async () => {
  let sources = [];

  const connectionConfig = {};
  const connectionResults = {};
  const connections = Object.keys(connectionsEnum);
  const results = await Promise.all(connections.map((connection) => SyncService.checkConnection(connection)));

  connections.forEach((connection, index) => {
    connectionResults[connection] = results[index];
    connectionConfig[connection] = !(results[index]?.status >= 400);
  });

  sources = [
    ...connections
      .map((connection) => {
        if (!connectionConfig[connection]) {
          return null;
        }

        return {
          label: connectionsEnum[connection].label,
          value: connectionsEnum[connection].value
        };
      })
      .filter(Boolean),
    ...sources
  ].sort((a, b) => a.label.localeCompare(b.label));

  return {
    connectionSettings: connectionConfig,
    connectionConfigs: sources
  };
};
